import React from "react";

const JumboContentLayoutContext = React.createContext({});

export default JumboContentLayoutContext;